import {all, call, put} from 'redux-saga/effects';
import {GET_USER_INFO_ERROR, GET_USER_INFO_SUCCESS} from '../../constants/UserConstants';
import {ISkeletonSaga, skeletonSaga} from '../../apis/skeleton/skeletonSaga';
import {GetBookmakersCall, GetUserInfoCall} from "../../apis/user";
import {GetFixturesCall} from "../../apis/fixture";
import {BookmakerData, EventStoredObject, MarketCapObject, MoneyLineObject, User} from "../../@types/response";
import {
    GET_EVENT_MONEY_LINE_SUCCESS,
    GET_MARKET_CAP_SUCCESS,
    SET_BOOKMAKERS,
    SET_FIXTURES
} from "../../constants/CommonConstants";
import {GetEventsMoneyLineCall, GetMarketCapCall} from "../../apis/events";

function* tryFunction() {
    const token = localStorage.getItem('sessionToken');
    if (!token) {
        throw Error('Token not valid');
    }

    const user: User = yield call(GetUserInfoCall)
    if (!user) {
        throw Error('User not logged in');
    }

    const [bookmakers, fixtures, moneyLines, marketCap]: [BookmakerData, EventStoredObject[], MoneyLineObject, MarketCapObject] = yield all([
        call(GetBookmakersCall),
        call(GetFixturesCall),
        call(GetEventsMoneyLineCall),
        call(GetMarketCapCall),
    ]);

    yield put({type: GET_USER_INFO_SUCCESS, payload: Object.assign({}, user)});
    yield put({type: SET_BOOKMAKERS, payload: bookmakers});
    yield put({type: SET_FIXTURES, payload: fixtures});
    yield put({type: GET_EVENT_MONEY_LINE_SUCCESS, payload: moneyLines});
    yield put({type: GET_MARKET_CAP_SUCCESS, payload: marketCap});
}

export function* getUserInfoSaga(): Generator {
    const sagaPayload: ISkeletonSaga = {
        tryApiCall: {function: tryFunction},
        failedType: GET_USER_INFO_ERROR
    };
    yield call(skeletonSaga, sagaPayload);
}
